import React from 'react';

import Slider from '@material-ui/core/Slider';

/**
 * Display to show / select the search radius within which the user would like to search from their current location (in miles)
 * @param {*} props 
 * @author BrianCastor
 */
export default function SearchRadiusSelector(props) {
  const field = 'how_far_to_receive__c';

  if (!props.userData[field]) {
    let newData = {}
    newData[field] = 10;
    props.updateUserData(newData);
  }

  function handleSearchRadiusChange(newValue) {
    let newData = {}
    newData[field] = newValue;
    props.updateUserData(newData);
  }

  return (
    <div>
      <h3>How far would you like to search?</h3>
      <Slider
        defaultValue={10}
        value={props.userData[field] || 10}
        max={10}
        valueLabelDisplay="auto"
        getAriaValueText={(value) => `${value} miles`}
        aria-labelledby="discrete-slider-restrict"
        step={null}
        marks={[{ value: 1, label: '1 mile' }, { value: 3, label: '3 miles' }, { value: 6, label: '6 miles' }, { value: 10, label: '10 miles' }]}
        style={{ width: '90%' }}
        onChange={(event, newValue) => handleSearchRadiusChange(newValue)}
      />
    </div>
  );
}